/**
 * Il rito di backup chiede alcune parole a caso fra le dodici. Quali parole
 * vengono chieste non è un dettaglio estetico: è l'unica cosa che distingue
 * una verifica da una formalità. Per questo la scelta viene da `crypto` e non
 * da `Math.random`.
 */
function randomBelow(bound: number): number {
  // Scarta la coda che renderebbe il modulo sbilanciato: senza questo taglio i
  // primi indici uscirebbero un po' più spesso degli ultimi.
  const limit = Math.floor(0x1_0000_0000 / bound) * bound;
  const buffer = new Uint32Array(1);
  let value = limit;
  while (value >= limit) {
    crypto.getRandomValues(buffer);
    value = buffer[0]!;
  }
  return value % bound;
}

/**
 * Estrae `count` posizioni distinte fra 0 e `total - 1`, in ordine crescente.
 * L'ordine non è cosmesi: "Parola 2, Parola 5, Parola 11" si compila leggendo
 * il foglio una volta sola, invece di saltare avanti e indietro.
 */
export function pickChallengeIndexes(total: number, count: number): number[] {
  const wanted = Math.min(count, total);
  const pool = Array.from({ length: total }, (_, index) => index);
  // Fisher-Yates parziale: mescola solo quanto serve, e le posizioni restano
  // distinte per costruzione invece che per tentativi ripetuti.
  for (let position = 0; position < wanted; position += 1) {
    const swap = position + randomBelow(total - position);
    const held = pool[position]!;
    pool[position] = pool[swap]!;
    pool[swap] = held;
  }
  return pool.slice(0, wanted).sort((first, second) => first - second);
}

/**
 * La tastiera del telefono scrive `Ability` dove la frase dice `ability`, e un
 * confronto rigido trasformerebbe quella maiuscola in un backup mai confermato.
 * Normalizza solo la risposta: la wordlist BIP39 inglese è già tutta minuscola,
 * e lo stesso trattamento è quello che `identityFromMnemonic` applica al
 * ripristino della frase.
 */
export function matchesWord(answer: string, expected: string): boolean {
  return answer.trim().toLowerCase() === expected;
}
